import { usePathname } from 'next/navigation'
import { AnimatePresence, motion } from 'motion/react'
import { Footer } from './Global/Footer'

export const Transition = ({ component, pageProps, path }): JSX.Element => {
  const pathname = usePathname()
  const Component = component

  return (
    <AnimatePresence mode="wait" initial={true}>
      <motion.div
        className="flex min-h-screen flex-col"
        key={pathname}
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
        }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.35,
          ease: 'easeInOut',
        }}
      >
        <div className="flex-1">
          <Component {...pageProps} />
        </div>
        <Footer
          menus={pageProps?.settings?.footerMenus ?? []}
          logo={pageProps?.settings?.logo}
        />
      </motion.div>
    </AnimatePresence>
  )
}
